import React from 'react'
import { connect } from 'redaction'

import Queue from '../Queue'


export default connect({
  items: (state) => {
    const { models: { queue } } = state

    return queue.items
  },
})(Queue)
